import React, { useEffect, useRef, useState } from "react";
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";
import { AvForm, AvField } from "availity-reactstrap-validation";
import filterFactory, { selectFilter } from "react-bootstrap-table2-filter";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Label,
  Spinner,
} from "reactstrap";

import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

import Breadcrumb from "../../../../components/Common/Breadcrumb";

import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";

import { postSubmitForm } from "../../../../helpers/forms_helper";
import moment from "moment";
import Line from "../../../AllCharts/echart/linechart";
import showNotification from "../../../../helpers/show_notification";
import printDiv from "../../../../helpers/print_data";
import {
  ExportAvailableInCSVForReports,
  formatUnitsForReport,
} from "../../../../helpers/units";

const ItemCostTrendReport = (props) => {
  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }

  const { SearchBar } = Search;
  const [selectedRow, setSelectedRow] = useState([]);
  const [selectedItem, setSelectedItem] = useState("-Select-");
  const [allItems, setAllItems] = useState([]);
  const [dateFrom, setDateFrom] = useState();
  const [dateTo, setDateTo] = useState();
  const [isLoadingOrders, setIsLoadingOrders] = useState(false);
  const [pageSize, setPageSize] = useState(50);
  const ordersRequestId = useRef(0);

  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  useEffect(() => {
    const currentDay = new Date();
    setDateFrom(formatDate(currentDay));
    setDateTo(formatDate(currentDay));
    loadAllItems();
  }, []);

  useEffect(() => {
    if (dateFrom > dateTo) {
      setFilteredOrders([]);
      setAllOrders([]);
      setItemsLineChartData();
    }
  }, [dateFrom, dateTo]);

  const [allOrders, setAllOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);

  const loadOrders = async () => {
    const requestId = ++ordersRequestId.current;
    try {
      if (!selectedItem || selectedItem === "-Select-") {
        showNotification(props.t("Item cannot be empty."), "Error");
        return false;
      }

      const daysDiff = moment(dateTo).diff(dateFrom, "days");
      if (daysDiff > 31) {
        setFilteredOrders([]);
        showNotification(
          "Total number of days cannot be more than 31.",
          "Error",
        );
        return false;
      } else if (daysDiff < 0) {
        setFilteredOrders([]);
        showNotification("Invalid date range.", "Error");
        return false;
      }

      setIsLoadingOrders(true);
      setFilteredOrders([]);
      const url =
        process.env.REACT_APP_BASEURL + "reports/item_cost_trend_report";
      const response = await postSubmitForm(url, {
        item_id: selectedItem,
        date_from: dateFrom,
        date_to: dateTo,
      });
      if (requestId !== ordersRequestId.current) return false;
      if (response && response.status === 1) {
        const allData = (response.data.purchaseorders_data || []).map(
          (row, index) => ({
            ...row,
            row_key:
              row.id ||
              `${row._id}_${(row.items && row.items.item_id) || index}_${index}`,
            branch_name:
              row.branch_details && row.branch_details.name
                ? row.branch_details.name
                : "",
            supplier_name:
              row.supplier && row.supplier.name ? row.supplier.name : "",
          }),
        );
        setItemsLineChartData(response.data.purchaseorders_chart);
        setAllOrders(allData);
        setFilteredOrders(allData);
      } else {
        showNotification((response && response.message) || "Error", "Error");
      }
    } catch (error) {
      if (requestId !== ordersRequestId.current) return false;
      console.log(error);
    } finally {
      if (requestId === ordersRequestId.current) {
        setIsLoadingOrders(false);
      }
    }
  };

  const loadAllItems = async () => {
    let url = process.env.REACT_APP_BASEURL + "items/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      setAllItems(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const columns = [
    {
      dataField: "row_key",
      hidden: true,
    },
    {
      dataField: "serial",
      isDummyField: true,
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      text: props.t("Purchase Order"),
      dataField: "po_id",
      formatter: (cell, row) => {
        return (
          <a
            href={"/purchase_order?po_id=" + row._id}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "blue" }}
          >
            {row.po_id}
          </a>
        );
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      text: props.t("Branch"),
      dataField: "branch_name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
      filter: selectFilter({
        options: () => {
          const unique = [
            ...new Map(
              allOrders
                .filter((row) => row && row.branch_name)
                .map((row) => [
                  row.branch_name,
                  { value: row.branch_name, label: row.branch_name },
                ]),
            ).values(),
          ];
          return unique.sort(dynamicSort("label"));
        },
      }),
    },
    {
      dataField: "supplier_name",
      text: props.t("Supplier Name"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
      filter: selectFilter({
        options: () => {
          const unique = [
            ...new Map(
              allOrders
                .filter((row) => row && row.supplier_name)
                .map((row) => [
                  row.supplier_name,
                  { value: row.supplier_name, label: row.supplier_name },
                ]),
            ).values(),
          ];
          return unique.sort(dynamicSort("label"));
        },
      }),
      style: { cursor: "pointer" },
    },
    {
      text: props.t("Status"),
      dataField: "status",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
      filter: selectFilter({
        options: () => {
          const unique = [
            ...new Map(
              allOrders
                .filter((row) => row && row.status)
                .map((row) => [
                  row.status,
                  { value: row.status, label: row.status },
                ]),
            ).values(),
          ];
          return unique.sort(dynamicSort("label"));
        },
      }),
    },
    {
      text: props.t("Date"),
      dataField: "createdAt",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      formatter: (cell, row) => {
        return moment(row.createdAt).format("DD/MM/YYYY");
      },
    },
  ];

  const [orderDetailsModal, setOrderDetailsModal] = useState();
  const [itemsLineChartData, setItemsLineChartData] = useState();

  const rowStyle = (row) => {
    const style = {};
    if (row.status === "Completed") {
      style.backgroundColor = "#b0ff9e";
    } else if (row.status === "Booked") {
      style.backgroundColor = "#9ec3ff";
    } else if (row.status === "In Process") {
      style.backgroundColor = "#fffd9e";
    } else if (row.status === "Cancelled") {
      style.backgroundColor = "#ff9e9e";
    }
    return style;
  };

  function afterFilter(newResult) {
    setFilteredOrders((prevOrders) => {
      const next = newResult || [];
      if (
        prevOrders.length === next.length &&
        prevOrders.every((row, index) => row === next[index])
      ) {
        return prevOrders;
      }
      return next;
    });
  }

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} - {to} of {size} records.
    </span>
  );

  const pagination_options = {
    sizePerPage: pageSize,
    onSizePerPageChange: (sizePerPage) => {
      setPageSize(sizePerPage);
    },
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "200", value: 200 },
    ],
    hideSizePerPage: false,
    ignoreSinglePage: true,
  };

  const handleDownload = async () => {
    const fileName = "item_cost_trend_report";
    const exportType = "xls";

    let data_to_export =
      filteredOrders && filteredOrders.length ? filteredOrders : allOrders;
    if (data_to_export) {
      var data = [];
      data_to_export.forEach(function (v) {
        data.push({
          Item: v.items && v.items.name,
          Category: v.items && v.items.category,
          Sub_Category: v.items && v.items.sub_category,
          Quantity: ExportAvailableInCSVForReports(v.items && v.items.quantity),
          Price: v.items && v.items.price,
          Branch: v.branch_name,
          Supplier: v.supplier_name,
          Status: v.status,
          "PO ID": v.po_id,
          Date: v.createdAt ? moment(v.createdAt).format("DD/MM/YYYY") : "",
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };

  const columns_ordered_items = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      text: props.t("Sub-Category"),
      dataField: "sub_category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      text: props.t("Item"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      dataField: "unit",
      text: props.t("Available"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.available);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "unit",
      text: props.t("Order Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
  ];

  const columns_delivered_items = [
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      text: props.t("Sub-Category"),
      dataField: "sub_category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      text: props.t("Item"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      text: props.t("Batch"),
      dataField: "batch",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "unit",
      text: props.t("Delivered Qty."),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.delivered_quantity);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "received_quantity",
      text: props.t("Rec. Qty."),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.received_quantity);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb
            alternateTitle={props.t("Item Cost Trend Report")}
            title={props.t("Reports")}
            breadcrumbItem={props.t("Item Cost Trend Report")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm>
                    <Row>
                      <Col lg={3}>
                        <AvField
                          name="item"
                          label={props.t("Item")}
                          type="select"
                          value={selectedItem}
                          onChange={(e) => {
                            setSelectedItem(e.target.value);
                          }}
                          errorMessage={props.t("Item cannot be empty.")}
                          validate={{
                            required: { value: true },
                          }}
                        >
                          <option value="-Select-">
                            {props.t("-Select-")}
                          </option>
                          {allItems &&
                            allItems.map((item) => {
                              return (
                                <option key={item._id} value={item._id}>
                                  {item.name}
                                </option>
                              );
                            })}
                        </AvField>
                      </Col>
                      <Col lg={3}>
                        <AvField
                          name="dateFrom"
                          label={props.t("From Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateFrom}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateFrom(formatDate(selectedDate));

                            const maxDate = moment(selectedDate)
                              .add(30, "days")
                              .format("YYYY-MM-DD");
                            const currentDate = moment().format("YYYY-MM-DD");

                            if (
                              moment(dateTo).isAfter(maxDate) ||
                              moment(dateTo).isAfter(currentDate)
                            ) {
                              setDateTo(
                                maxDate > currentDate ? currentDate : maxDate,
                              );
                            }
                          }}
                          max={moment().format("YYYY-MM-DD")}
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={3}>
                        <AvField
                          name="dateTo"
                          label={props.t("To Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateTo}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateTo(formatDate(selectedDate));
                          }}
                          min={dateFrom}
                          max={
                            moment(dateFrom)
                              .add(30, "days")
                              .format("YYYY-MM-DD") >
                            moment().format("YYYY-MM-DD")
                              ? moment().format("YYYY-MM-DD")
                              : moment(dateFrom)
                                  .add(30, "days")
                                  .format("YYYY-MM-DD")
                          }
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={3}>
                        <Button
                          type="button"
                          className="btn btn-md btn-success mt-4"
                          disabled={isLoadingOrders}
                          onClick={() => {
                            if (dateFrom && dateTo) {
                              loadOrders();
                            }
                          }}
                        >
                          {isLoadingOrders ? (
                            <Spinner size="sm" className="mr-1" />
                          ) : (
                            <i className="mdi mdi-checkbox-marked-circle"></i>
                          )}{" "}
                          {props.t("Check")}
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="button"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      {"   "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>
                  {isLoadingOrders ? (
                    <div className="text-center py-5">
                      <Spinner color="primary" />
                    </div>
                  ) : (
                    <>
                      <Row>
                        <Col lg="12">
                          <Card>
                            <CardBody>
                              <div id="line-chart" className="e-chart">
                                <Line
                                  line_data={
                                    itemsLineChartData && itemsLineChartData
                                  }
                                />
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                      <div id="printDiv">
                        <CardTitle className="text-center">
                          {props.t("Item Cost Trend Report")}
                        </CardTitle>
                        <ToolkitProvider
                          keyField="row_key"
                          data={allOrders && allOrders}
                          columns={columns}
                          noDataIndication={props.t("No data to display.")}
                          bootstrap4
                          search
                        >
                          {(toolkitProps) => (
                            <div>
                              <Row>
                                <Col lg={4}>
                                  <SearchBar
                                    {...toolkitProps.searchProps}
                                    style={{ width: "300px" }}
                                  />
                                </Col>
                                <Col lg={4}></Col>
                                <Col lg={4}></Col>
                              </Row>
                              <BootstrapTable
                                striped
                                hover
                                condensed
                                rowStyle={rowStyle}
                                filter={filterFactory({ afterFilter })}
                                pagination={paginationFactory(
                                  pagination_options,
                                )}
                                {...toolkitProps.baseProps}
                              />
                            </div>
                          )}
                        </ToolkitProvider>
                      </div>
                    </>
                  )}

                  <Modal
                    size="lg"
                    isOpen={orderDetailsModal}
                    toggle={() => setOrderDetailsModal(!orderDetailsModal)}
                  >
                    <ModalHeader
                      toggle={() => setOrderDetailsModal(!orderDetailsModal)}
                    >
                      {props.t("Order Details")}
                    </ModalHeader>
                    <ModalBody>
                      <>
                        <Row>
                          <Col lg={12}>
                            <Card>
                              <CardBody>
                                <Row>
                                  <Col lg={12} md={12}>
                                    <Label>Ordered Items</Label>
                                  </Col>

                                  <Col lg={12}>
                                    <BootstrapTable
                                      bootstrap4
                                      keyField="name"
                                      data={
                                        selectedRow && selectedRow.item_details
                                      }
                                      columns={columns_ordered_items}
                                      noDataIndication="No data to display."
                                      striped
                                      hover
                                      condensed
                                    />
                                    <hr />
                                  </Col>

                                  {selectedRow &&
                                  selectedRow.delivery_details &&
                                  selectedRow.delivery_details.length > 0 ? (
                                    <>
                                      <Col lg={12} md={12}>
                                        <br />
                                        <Label>
                                          <b>{props.t("Delivered Items")} </b>
                                        </Label>
                                      </Col>
                                      <Col lg={12} className="mb-4">
                                        <BootstrapTable
                                          bootstrap4
                                          keyField="name"
                                          key="name"
                                          data={selectedRow.delivery_details}
                                          columns={columns_delivered_items}
                                          noDataIndication="No data to display."
                                          striped
                                          hover
                                          condensed
                                        />
                                        <hr />
                                      </Col>
                                    </>
                                  ) : null}
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      </>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(ItemCostTrendReport)),
);
